export default "__VITE_ASSET__BUfhIBMp__"